// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verification[data-v-94843500] {\n  display: inline-block;\n}\n.verification .el-button[data-v-94843500] {\n    width: 130px;\n    margin-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
